import React from "react";
import { useSubmit, useNavigation, useActionData } from "react-router";
import { Card, Button, Form, FloatingLabel } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { renderSimpleToast } from "components/shared/Toasts";
import { ForgotPasswordSchema } from "schema/account";
import { renderLoadingProgressToast } from "components/shared/Toasts";
import BackLink from "./BackLink";
import axios from "axios";

export async function action({ request }) {
    const updates = await request.json();
    var result = await renderLoadingProgressToast(
        axios.post(
            "account/forgot-password",
            ForgotPasswordSchema.cast(updates)
        )
    )
        .then(() => ({ success: true }))
        .catch((error) => {
            if (error.response?.data) {
                var data = error.response?.data;
                return Promise.resolve({
                    success: false,
                    reason: data["description"],
                });
            }
            return Promise.reject(error);
        });
    if (result.success === true) {
        renderSimpleToast("Reset password email sent.");
        return null;
    }
    return result;
}

const ForgotPassword = () => {
    const submit = useSubmit();
    const actionData = useActionData();
    const navigation = useNavigation();
    const isNavigating =
        navigation.state === "submitting" || navigation.state === "loading";

    const onSubmit = async (data) => {
        await submit(data, {
            action: "/account/forgot-password",
            method: "post",
            encType: "application/json",
        });
    };

    const onError = (errors, e) => console.error(errors, e);

    const {
        handleSubmit,
        control,
        formState: { errors },
        reset,
    } = useForm({
        resolver: yupResolver(ForgotPasswordSchema),
        defaultValues: {
            email: "",
        },
    });

    return (
        <div style={{ width: "100%", maxWidth: "350px", margin: "0 auto" }}>
            <BackLink />
            <Card className="mt-3" style={{ width: "100%" }} border="secondary">
                <Card.Header>Forgot Password</Card.Header>
                <Card.Body>
                    <Form
                        onSubmit={handleSubmit(onSubmit, onError)}
                        onReset={reset}
                    >
                        <Form.Group className="mb-3">
                            <Controller
                                control={control}
                                name="email"
                                render={({
                                    field: { onChange, value, ref },
                                }) => (
                                    <FloatingLabel
                                        controlId="email"
                                        label="Email"
                                    >
                                        <Form.Control
                                            type="email"
                                            name="email"
                                            isInvalid={errors.email}
                                            placeholder="Email"
                                            onChange={onChange}
                                            value={value}
                                            ref={ref}
                                            rules={{ required: true }}
                                            data-testid="input_email"
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.email?.message}
                                        </Form.Control.Feedback>
                                    </FloatingLabel>
                                )}
                            />
                        </Form.Group>
                        {actionData?.reason && (
                            <div className="text-danger mb-3">
                                {actionData.reason}
                            </div>
                        )}
                        <div className="d-grid gap-2">
                            <Button
                                type="submit"
                                variant="primary"
                                disabled={isNavigating}
                            >
                                Send
                            </Button>
                        </div>
                    </Form>
                </Card.Body>
            </Card>
        </div>
    );
};

export default ForgotPassword;
